import { Assets, ColorMatrixFilter, Texture } from "pixi.js";
import { PART_SPRITE_DEFS } from "./partSprites";

const textureCache = new Map<string, Texture>();
const hueFilterCache = new Map<number, ColorMatrixFilter>();
let preloadPromise: Promise<void> | null = null;

export function registerPartAssets(): void {
  for (const def of PART_SPRITE_DEFS) {
    Assets.add({ alias: def.key, src: def.file });
  }
}

export async function preloadPartTextures(): Promise<void> {
  if (preloadPromise) return preloadPromise;

  registerPartAssets();
  preloadPromise = (async () => {
    await Assets.load(PART_SPRITE_DEFS.map((def) => def.key));
    for (const def of PART_SPRITE_DEFS) {
      const texture = Assets.get<Texture>(def.key);
      if (texture) textureCache.set(def.key, texture);
    }
  })();

  return preloadPromise;
}

export function getPartTexture(spriteKey: string): Texture {
  const cached = textureCache.get(spriteKey);
  if (cached) return cached;

  const fromAssets = Assets.get<Texture>(spriteKey);
  if (fromAssets) {
    textureCache.set(spriteKey, fromAssets);
    return fromAssets;
  }

  return Texture.EMPTY;
}

export function getHueFilter(hueShift: number): ColorMatrixFilter | null {
  if (hueShift === 0) return null;

  let filter = hueFilterCache.get(hueShift);
  if (!filter) {
    filter = new ColorMatrixFilter();
    filter.hue(hueShift, false);
    hueFilterCache.set(hueShift, filter);
  }

  return filter;
}
